import { SxProps, Theme, alpha } from '@mui/material';

const container: SxProps<Theme> = (theme) => ({
  marginTop: 2,
  backgroundColor: alpha(theme.palette.primary.main, 0.05),
});

const wrapper = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
};

const picker = {
  position: 'absolute',
  zIndex: 9,
  bottom: '45px',
};

const emojiButton: SxProps<Theme> = (theme) => ({
  borderRadius: 1,
  border: '1px solid',
  marginRight: 1,
  borderColor: alpha(theme.palette.primary.main, 0.5),
});

const emojiCounter = {
  fontSize: 15,
  marginLeft: 0.5,
};

export default {
  container,
  wrapper,
  picker,
  emojiCounter,
  emojiButton,
};
